export const CRLF = '\r\n';
export const CRLF2 = CRLF + CRLF;